import { ValidatorFn } from '@angular/forms';
import {
  IDateRangeValidationHandler,
  IFileTypeValidationHandler,
  IFileValidationHandler,
  IListValidationHandler,
  INumericValidationHandler,
  IRangeValidationHandler,
  IServerValidationHandler,
  IValidationHandler,
  TValidator
} from '../model';
import { creditCardValidator } from './credit-card/credit-card.validator';
import { dateRangeValidator } from './dates';
import { emailValidator } from './email/email.validator';
import { emptyListValidator } from './empty-list';
import { englishNameValidator } from './english-name/engname.validator';
import { maxFileSizeValidator } from './file';
import { fileTypeValidator } from './file/file-type.validator';
import { minFileSizeValidator } from './file/min-file-size.validator';
import { hebrewConsecutiveCharsValidator } from './hebrew-consecutive-chars/hebrewconsecutivechars.validator';
import { hebrewNameValidator } from './hebrew-name/hebname.validator';
import { idNumberValidator } from './id-number/id-number.validator';
import { maxLengthValidator } from './min-max-length/max-length.validator';
import { minLengthValidator } from './min-max-length/min-length.validator';
import { mobilePhoneValidator } from './mobile-phone/mobile-phone.validator';
import { maxNumericValidator, minNumericValidator, multiplierValidator } from './numeric';
import { numericValidator } from './numeric/numeric.validator';
import { patternValidator } from './pattern/pattern.validator';
import { severityValidator } from './severity/severity.validator';
import { specificLengthValidator } from './specific-length';

export type TCustomValidator =
  | 'idNumber'
  | 'creditCard'
  | 'hebrewName'
  | 'englishName'
  | 'hebrewConsecutiveChars'
  | 'numeric'
  | 'email'
  | 'mobilePhone'
  | 'pattern'
  | 'numeric'
  | 'minNumeric'
  | 'maxNumeric'
  | 'minLength'
  | 'maxLength'
  | 'emptyList'
  | 'dateRange'
  | 'severity'
  | 'maxFileSize'
  | 'fileType';

export const CustomValidators: { [key in TValidator]?: ({ ...args }: IValidationHandler) => ValidatorFn } = {
  idNumber: ({ ...args }: IValidationHandler) => idNumberValidator(args),
  creditCard: ({ ...args }: IValidationHandler) => creditCardValidator(args),
  hebrewName: ({ ...args }: IValidationHandler) => hebrewNameValidator(args),
  englishName: ({ ...args }: IValidationHandler) => englishNameValidator(args),
  numeric: ({ ...args }: INumericValidationHandler) => numericValidator(args),
  multiplier: ({ ...args }: INumericValidationHandler) => multiplierValidator(args),
  email: ({ ...args }: IValidationHandler) => emailValidator(args),
  mobilePhone: ({ ...args }: IValidationHandler) => mobilePhoneValidator(args),
  pattern: ({ ...args }: IValidationHandler) => patternValidator(args),
  hebrewConsecutiveChars: ({ ...args }: IValidationHandler) => hebrewConsecutiveCharsValidator(args),
  maxFileSize: ({ ...args }: IFileValidationHandler) => maxFileSizeValidator(args),
  minFileSize: ({ ...args }: IFileValidationHandler) => minFileSizeValidator(args),
  fileType: ({...args}: IFileTypeValidationHandler) => fileTypeValidator(args)
};

export const CustomServerValidators: { [key in TValidator]?: ({ ...args }: IServerValidationHandler) => ValidatorFn } =
  {
    severity: ({ ...args }: IServerValidationHandler) => severityValidator(args)
  };

export const CustomRangeValidators: {
  [key in TValidator]?: ({ ...args }: Partial<IRangeValidationHandler<any>>) => ValidatorFn;
} = {
  minNumber: ({ ...args }: Partial<IRangeValidationHandler<number>>) => minNumericValidator(args),
  maxNumber: ({ ...args }: Partial<IRangeValidationHandler<number>>) => maxNumericValidator(args),
  minLength: ({ ...args }: Partial<IRangeValidationHandler<number>>) => minLengthValidator(args),
  maxLength: ({ ...args }: Partial<IRangeValidationHandler<number>>) => maxLengthValidator(args),
  specificLength: ({ ...args }: Partial<IRangeValidationHandler<number>>) => specificLengthValidator(args)
};

export const CustomDateValidators: {
  [key in TValidator]?: ({ ...args }: IRangeValidationHandler<any>) => ValidatorFn;
} = {
  dateRange: ({ ...args }: IDateRangeValidationHandler<string>) => dateRangeValidator(args)
};

export const CustomListValidators: {
  [key in TCustomValidator]?: ({ ...args }: IListValidationHandler) => ValidatorFn;
} = {
  emptyList: ({ ...args }: IListValidationHandler) => emptyListValidator(args)
};
